import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const HomepageVideoCard = ({ 
  videoUrl,
  title = "See it in action",
  description = "Watch our AI-generated recap to see what your league could look like"
}) => {
  // Convert YouTube Shorts URL to embed format
  const getEmbedUrl = (url) => {
    if (!url) return '';
    
    // Handle YouTube Shorts URLs
    if (url.includes('youtube.com/shorts/')) {
      const videoId = url.split('youtube.com/shorts/')[1].split('?')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    
    // Handle regular YouTube URLs
    if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('v=')[1].split('&')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    
    // If already an embed URL, return as is
    if (url.includes('youtube.com/embed/')) {
      return url;
    }
    
    return url;
  };

  const embedUrl = getEmbedUrl(videoUrl);

  return (
    <section className="py-5" id="sample">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={12}>
            <div className="glass-card text-center homepage-video-card">
              <h2 className="display-2 mb-5">{title}</h2>
              <p className="lead mb-5">{description}</p>
              <div className="video-container homepage-video-container mb-4">
                <iframe
                  width="100%"
                  height="100%"
                  src={embedUrl}
                  title={`RecapVid Sample Video`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomepageVideoCard;
